<article class="validate-phone-form-wrapper">
  <ng-container *ngIf="!showChangeMethodCode">
    <ng-container *ngIf="isEditPhone">
      <h2 class="text">Ingresa el código que recibiste vía SMS</h2>
      <h4 class="sub-title">Se envío al número {{ maskedPhone }}</h4>
      <span class="secondary-text">Puede tardar algunos segundos.</span>
    </ng-container>
    <form [formGroup]="smsValidationForm"
          class="sign-up-form"
          autocomplete="off"
          *ngIf="!showWhatsApp; else whatsAppContact">
      <section class="token-form">
        <div class="form-group token">
          <input type="text"
                 class="form-control"
                 aria-describedby="Token"
                 placeholder="Código de validación"
                 maxlength="6"
                 formControlName="token"
                 [id]="idPrefix + 'validate-phone-token'"
                 (keyup.enter)="validate()"
                 autocomplete="off">

          <small class="text-danger"
                 [id]="idPrefix + 'validate-phone-token-error'"
                 *ngIf="error.token">
            {{ error.token }}
          </small>
        </div>
      </section>

      <section class="">
        <app-button
                    class="validate-app-button"
                    [title]="'Verificar'"
                    [isDisabled]="!smsValidationForm.valid"
                    [customClasses]="'main full-width sign-up-button'"
                    [isLoading]="isLoading"
                    [buttonId]="idPrefix + 'validate-phone-validate'"
                    (click)="validate()"></app-button>

        <app-button
                    class="validate-app-button"
                    [title]="'Reenviar'"
                    [isDisabled]="reSendDisabled"
                    [customClasses]="'transparent full-width'"
                    [isLoading]="isLoading"
                    [buttonId]="idPrefix + 'validate-phone-re-send'"
                    [class.d-none]="countDownCounter >= 0 || hideReSend"
                    (click)="reSend()"></app-button>
      </section>

      <p class="counter-text text-center" *ngIf="countDownCounter >= 0">Vuelve a solicitar el código en <strong>{{countDownCounter}} segundos</strong></p>
    </form>

    <ng-template #whatsAppContact>
      <div *ngIf="!isEditPhone" class="text-center font-15">
        <p>Comunícate con nosotros por Whatsapp al número</p>
        <a href="https://api.whatsapp.com/send?phone=573176480137" rel="noreferrer noopener" target="_blank">+ 57 317 648 01 37</a>
      </div>
    </ng-template>

    <div *ngIf="!isEditPhone" class="change-notification-type">
      <h5>¿No recibiste el código?</h5>
      <p>
        <a (click)="changeMethodOfCode()">Selecciona otras opciones para recibir el código</a>
      </p>
    </div>

  </ng-container>

  <ng-container *ngIf="showChangeMethodCode">
    <app-select-method-code
      [sms] = "true"
      [call] = "true"
      [email] = "false"
      [customer] = "phone"
      [isSingUp] = "true"
      (closeSelect) = "closeSelect($event)"
      (newCode) = "changeNewCode($event)"
    ></app-select-method-code>
    <a class="support" (click)="openZdWidget()">Contactar a soporte</a>
  </ng-container>



  <app-overlay [isLoading]="false"></app-overlay>
</article>
